







export default {
  name: 'DumbbellIcon',
  props: {
    color: {
      type: String,
      default: '#000'
    }
  }
}

